module.exports = "<nav class=breadcrumb> <div class=breadcrumb-wrap> <a class=breadcrumb-item ui-sref=home translate>Home</a> <a class=breadcrumb-item ui-sref=\".product({productId: vm.product.id})\">{{::vm.product.name}}</a> <b class=breadcrumb-item>News</b> </div> </nav> <h1>{{'News' | translate }} {{::vm.product.name}}</h1> <news-overview model=vm.newsOverviewModel view-mode=\"r-sm-2-col r-md-3-col r-lg-4-col r-xl-4-col r-xx-4-col\"></news-overview>";


//////////////////
// WEBPACK FOOTER
// ./features/product/news.html
// module id = 642
// module chunks = 0